import { render, staticRenderFns } from "./DirectDeposit.vue?vue&type=template&id=12144556&scoped=true"
import script from "./DirectDeposit.vue?vue&type=script&lang=ts"
export * from "./DirectDeposit.vue?vue&type=script&lang=ts"
import style0 from "./DirectDeposit.vue?vue&type=style&index=0&id=12144556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12144556",
  null
  
)

export default component.exports